<template>
	<div class="login">
		<div class="loginBox">
			<div class="titleBox">用户登录</div>
			<div class="inputBpx">
				<div class="nameBox itemBox disBetween">
					<div class="my"></div>
					<span class="line"></span>
					<div class="textBpx">
						<el-input v-model="obj.value1" placeholder="请输入用户名 / 手机"></el-input>
					</div>
				</div>
				<div class="pasBox itemBox disBetween">
					<div class="pas"></div>
					<span class="line"></span>
					<div class="textBpx">
						<el-input placeholder="请输入密码" v-model="obj.value2" show-password></el-input>
					</div>
				</div>
				<div class="forget">忘记密码？</div>
			</div>
			<div class="loginBtn disCenter">
				<el-button @click="goLogin" type="primary">登录</el-button>
			</div>
		</div>
		<div class="valueBox disCenter" @click="goUrl"></div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	export default {
		data() {
			return {
				obj: {
					value1: "",
					value2: ""
				}
			}
		},
		mounted() {},
		methods: {
			goUrl(){
				window.open("https://beian.miit.gov.cn")
			},
			goLogin() {
				// alert("点击了登录")
				if (this.obj.value1.length == 0) {
					this.$message('请输入用户名');
					return
				}
				if (this.obj.value2.length == 0) {
					this.$message('请输入密码');
					return
				}
				this.gotoLogin()

			},
			gotoLogin() {
				this.$api.login({
					loginName: this.obj.value1,
					loginPassword: this.obj.value2
				}).then(res => {
					console.log(res);
					if (res.returnCode == 200) {
						localStorage.clear()
						Vue.prototype.$serviceProviderId=undefined
						Vue.prototype.$mainUser=undefined
						localStorage.setItem('token', res.obj.token)
						localStorage.setItem('userName', res.obj.userName)
						if(res.obj.serviceProviderId){
							Vue.prototype.$serviceProviderId = res.obj.serviceProviderId
							localStorage.setItem('serviceProviderId', res.obj.serviceProviderId)
						}
						if(res.obj.adminFlag===0 || res.obj.adminFlag==="0"){
							Vue.prototype.$mainUser=1
							localStorage.setItem('mainUser', 1)
						}
						
						let arr = []
						let menuObj = res.obj.permissionsModelList
						for (let k in menuObj) {
							if (menuObj[k].checkFlag) {
								arr.push({
									checkFlag: menuObj[k].checkFlag,
									children: [],
									parentPermissionsModelId: menuObj[k]
										.parentPermissionsModelId,
									path: menuObj[k].path,
									permissionsModelCode: menuObj[k].permissionsModelCode,
									permissionsModelId: menuObj[k].permissionsModelId,
									permissionsModelName: menuObj[k].permissionsModelName,
									permissionsModelPath: menuObj[k].permissionsModelPath,
								})
								
								for (let j in menuObj[k].children) {
									if (menuObj[k].children[j].checkFlag) {
										arr[arr.length-1].children.push({
											checkFlag: menuObj[k].children[j].checkFlag,
											children: [],
											parentPermissionsModelId: menuObj[k].children[j]
												.parentPermissionsModelId,
											path: menuObj[k].children[j].path,
											permissionsModelCode: menuObj[k].children[j]
												.permissionsModelCode,
											permissionsModelId: menuObj[k].children[j]
												.permissionsModelId,
											permissionsModelName: menuObj[k].children[j]
												.permissionsModelName,
											permissionsModelPath: menuObj[k].children[j]
												.permissionsModelPath,
										})
									}

								}
							}

						}
						console.log(arr)
						if (arr.length > 0) {
							setTimeout(() => {
								localStorage.setItem('menuL', JSON.stringify(arr))
								this.$router.push(arr[0].children[0].path)
							}, 1000)
						} else {
							this.$message('此账号无访问权限，请联系管理员');
						}

					} else {
						if (res.returnMessage) {
							this.$message(res.returnMessage);
						} else {
							this.$message('数据请求失败');
						}

					}


				}).catch(function(error) {
					console.log(error);
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "login.scss"
</style>